import layout from 'views/layout/';

export default {
  path: '/course',
  component: layout,
  meta: {
    breadNotLink: true,
    breadText: '课程'
  },
  children: [
    {
      path: 'private',
      alias: '/Web/PtSchedule/pt_schedule_list',
      name: '私教排课',
      component: resolve => require(['views/course/privateClass'], resolve),
      meta: {
        parentName: '课程'
      }
    },
    // {
    //   path: 'swim',
    //   alias: '/Web/PtSchedule/swim_schedule_list',
    //   name: '泳教排课',
    //   component: resolve => require(['views/course/privateClass'], resolve),
    //   meta: {
    //     parentName: '课程'
    //   }
    // },
    {
      path: 'privateTeam',
      alias: '/Web/TeamclassPrivate/teamclass_list',
      name: '私教（校课）管理',
      component: resolve => require(['views/course/teamClass'], resolve),
      meta: {
        parentName: '课程'
      }
    },
    // {
    //   path: 'swimTeam',
    //   alias: '/Web/TeamclassSwim/teamclass_list',
    //   name: '泳教班管理',
    //   component: resolve => require(['views/course/teamClass'], resolve),
    //   meta: {
    //     parentName: '课程'
    //   }
    // },
    {
      path: 'addTeamClass',
      name: '添加班级',
      component: resolve => require(['views/course/addTeamClass'], resolve),
      meta: {
        parentName: '班课管理'
      }
    },
    {
      path: 'privateSchedule',
      alias: '/Web/CourseSchedule/get_class_list',
      name: '班课排课',
      component: resolve => require(['views/course/scheduleWeek'], resolve),
      meta: {
        parentName: '课程'
      }
    },
    {
      path: 'openClass',
      alias: '/Web/OpenClass/get_open_class_list',
      name: '班课管理',
      component: resolve => require(['views/course/openClass'], resolve),
      meta: {
        parentName: '课程',
        breadText: '课种管理'
      },
      children: [
        {
          path: 'addClass',
          name: '添加班课',
          component: resolve => require(['views/course/addClass'], resolve),
          meta: {
            parentName: '班课管理'
          }
        },
        {
          path: 'editClass/:id',
          name: '班课编辑',
          component: resolve => require(['views/course/addClass'], resolve),
          meta: {
            parentName: '班课管理'
          }
        }
      ]
    }
  ]
}
